// extracted by mini-css-extract-plugin
export default {"itemContainer":"ProtocolListView_itemContainer__JjJI9"};